export default __webpack_public_path__ + "static/media/contributeSetPrice.b291e1ed.png";